import { Directive } from '@angular/core';
import { fromEvent } from 'rxjs';
import { Dropdown } from 'primeng/dropdown';

@Directive({
  selector: '[hideDropdownOnScroll]'
})
export class HideDropdownOnScrollDirective {

  constructor(dropDown: Dropdown) {

    const onScroll = fromEvent(window, 'scroll', { capture: true });


    onScroll.subscribe((event: Event) => {      
      const srcElement = <HTMLInputElement>event.target;
      const isPrimeNgContainingElement = ()=> {
        const a = srcElement.classList.contains('p-dropdown-items-wrapper');
        const b = srcElement.classList.contains('p-hidden-accessible');
        return a || b;
      };

      if (!isPrimeNgContainingElement()) {
        dropDown.hide();
      }
    });
  }

}
